import React from 'react';
import { ContentContainer } from '../ContentContainer';
import { Box, Typography } from '@mui/material';
import { ReferenceProfile } from './ReferenceProfile';
import { GenericToolbar } from '../GenericToolbar';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import { pushAppRoute } from '../../data/domain/route-manager';
import { useHistory } from 'react-router';
import { DeviceMasterProvider } from '../../data/DataProviders/DeviceMasterProvider';

export const AddManageDeviceProfile: React.FC = () => {
    const selectedOrganization = useSelectedOrganizationData();
    const orgId = isRecordFound(selectedOrganization) ? selectedOrganization.value.id : '';
    const history = useHistory();
    const navigateToManageDeviceProfile = (): void => {
        pushAppRoute(history, { type: 'ManageDeviceProfiles', orgId: orgId });
    };
    return (
        <>
            <GenericToolbar
                title={'Add Device Profile'}
                subtitle={'Manage Device Profiles'}
                showBackButton
                backButtonOnClick={navigateToManageDeviceProfile}
            />
            <ContentContainer>
                <Box sx={{}}>
                    <div>
                        <Typography variant="h6" display="inline" style={{ lineHeight: 1.5, fontWeight: 600 }}>
                            Add New Device Profile
                        </Typography>

                        <Typography
                            variant="body2"
                            display="block"
                            style={{ marginTop: 5, lineHeight: 1.25, fontWeight: 400 }}
                        >
                            Fields marked with an asterisk(*) are required fields when creating a profile.
                        </Typography>
                    </div>
                </Box>
                <DeviceMasterProvider>
                    <Box sx={{ mt: 5, minHeight: 100, overflow: 'auto' }}>
                        <ReferenceProfile />
                    </Box>
                </DeviceMasterProvider>
            </ContentContainer>
        </>
    );
};
